<template>
  <div class="flex w-full relative">
    <label
      class="checkbox-container flex flex-1 items-center relative pl-32 cursor-pointer select-none text-price z-30"
    >
      {{ text }}
      <input
        class="absolute opacity-0 cursor-pointer h-0 w-0"
        :type="isRadio ? 'radio' : 'checkbox'"
        :name="inputName"
        :checked="checked"
        :disabled="disabled"
        @change="onCheck"
      >
      <div
        class="checkmark absolute top-0 left-0 h-24 w-24 bg-white border border-default"
        :class="{
          'rounded-regular': !isRadio,
          'rounded-full': isRadio,
        }"
      />
      <fa class="check" :icon="['fas', 'check']" />
    </label>
    <div
      class="absolute -m-8 inset-0"
      :class="{
        'bg-picker': highlight && checked,
        'rounded-regular': !isRadio,
        'rounded-radio': isRadio,
      }"
    />
    <div v-if="highlight && checked && !isRadio && !disabled" class="absolute right-8">
      <fa class="text-primary" :icon="['fal', 'times']" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    inputName: {
      type: String,
      required: false,
      default: '',
    },
    checked: {
      type: Boolean,
      required: true,
    },
    highlight: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRadio: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onCheck(e: any) {
      this.$emit('onCheck', e.target.checked);
    },
  },
});
</script>

<style scoped>
.checkbox-container {
  padding-top: 5px;
}

.checkbox-container:hover input ~ .checkmark {
  @screen md {
    background-color: #ccc;
  }
}

.checkbox-container input:checked ~ .checkmark {
  @apply bg-primary;
  border: none;
}

.checkbox-container input:checked ~ .check {
  display: block;
  color: white;
}

.check {
  @apply text-xs;
  display: none;
  position: absolute;
  font-size: 12px;
  top: 7px;
  left: 6px;
}
</style>
